import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "q-pa-md" };
const _hoisted_2 = { class: "text-h4 text-bold text-green-7" };
const _hoisted_3 = {
    key: 0,
    class: "q-pa-md text-h5 text-bold text-red"
};
const _hoisted_4 = { class: "q-pa-md" };
const _hoisted_5 = { class: "q-mb-lg entry-check-table" };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { class: "multiline" };
const _hoisted_8 = {
    key: 0,
    class: "table-caption"
};
const _hoisted_9 = {
    key: 1,
    class: "q-mb-lg entry-check-table"
};
const _hoisted_10 = { class: "q-mb-lg entry-check-table" };
const _hoisted_11 = { class: "q-mb-lg entry-check-table" };
const _hoisted_12 = { key: 0 };
const _hoisted_13 = { class: "multiline" };
const _hoisted_14 = {
    key: 1,
    class: "q-pa-md"
};
const _hoisted_15 = { class: "entry-check-table" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_breadcrumb_list = _resolveComponent("breadcrumb-list");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_option_group = _resolveComponent("q-option-group");
    const _component_q_item = _resolveComponent("q-item");
    const _component_q_list = _resolveComponent("q-list");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_card_actions = _resolveComponent("q-card-actions");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_page = _resolveComponent("q-page");
    return (_openBlock(), _createBlock(_component_q_page, { class: "col column no-wrap" }, {
        default: _withCtx(() => [
            _createVNode(_component_breadcrumb_list, {
                breadCrumbs: [
                    { itemId: _ctx.PageID.top },
                    ...(_ctx.isMultipleKeiyaku
                        ? [{ itemId: _ctx.PageID.taikyoRoomList }]
                        : []),
                    { itemId: _ctx.PageID.taikyoFlowGuide },
                    ...(_ctx.isShinsei
                        ? [
                            { itemId: _ctx.PageID.taikyoPrecaution },
                            { itemId: _ctx.PageID.taikyoEntry }
                        ]
                        : []),
                    { itemId: _ctx.PageID.taikyoEntryCheck },
                ]
            }, null, 8, ["breadCrumbs"]),
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_q_card, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "bg-white" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.pageName), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_separator),
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                                (_ctx.taikyo.status === _ctx.NyukyoStatus.CurrentlyMovingIn)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, "入力に誤りがないか確認してください"))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_4, [
                                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "table-caption" }, "契約情報", -1)),
                                    _createElementVNode("table", _hoisted_5, [
                                        _createElementVNode("tbody", null, [
                                            _createElementVNode("tr", null, [
                                                _cache[3] || (_cache[3] = _createElementVNode("th", null, "契約者名", -1)),
                                                _createElementVNode("td", null, _toDisplayString(_ctx.personal.keiyakusha), 1)
                                            ]),
                                            (_ctx.nyukyokeiyaku?.roomSb !== _ctx.RoomSb.Parking)
                                                ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                                                    _cache[4] || (_cache[4] = _createElementVNode("th", null, "入居者名", -1)),
                                                    _createElementVNode("td", null, _toDisplayString(_ctx.nyukyokeiyaku?.nyukyosha), 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("tr", null, [
                                                _cache[5] || (_cache[5] = _createElementVNode("th", null, "住所", -1)),
                                                _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.nyukyokeiyaku?.addressAll), 1)
                                            ])
                                        ])
                                    ]),
                                    (_ctx.taikyo.sonotaKeiyaku)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, "その他"))
                                        : _createCommentVNode("", true),
                                    (_ctx.taikyo.sonotaKeiyaku)
                                        ? (_openBlock(), _createElementBlock("table", _hoisted_9, [
                                            _createElementVNode("tbody", null, [
                                                _createElementVNode("tr", null, [
                                                    _cache[6] || (_cache[6] = _createElementVNode("th", null, "その他ご契約事項", -1)),
                                                    _createElementVNode("td", null, _toDisplayString(_ctx.taikyo.sonotaKeiyaku), 1)
                                                ])
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "table-caption" }, "ご連絡先", -1)),
                                    _createElementVNode("table", _hoisted_10, [
                                        _createElementVNode("tbody", null, [
                                            _createElementVNode("tr", null, [
                                                _cache[7] || (_cache[7] = _createElementVNode("th", null, "携帯電話", -1)),
                                                _createElementVNode("td", null, _toDisplayString(_ctx.taikyo.tel), 1)
                                            ])
                                        ])
                                    ]),
                                    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "table-caption" }, "退去に伴う必要事項", -1)),
                                    _createElementVNode("table", _hoisted_11, [
                                        _createElementVNode("tbody", null, [
                                            _createElementVNode("tr", null, [
                                                _cache[8] || (_cache[8] = _createElementVNode("th", null, "退去予定日", -1)),
                                                _createElementVNode("td", null, _toDisplayString(_ctx.taikyo.taikyoYmd ? _ctx.dayjs(_ctx.taikyo.taikyoYmd).format("YYYY/MM/DD") : ""), 1)
                                            ]),
                                            _createElementVNode("tr", null, [
                                                _cache[9] || (_cache[9] = _createElementVNode("th", null, "解約日", -1)),
                                                _createElementVNode("td", null, _toDisplayString(_ctx.taikyo.kaiyakuYmd ? _ctx.dayjs(_ctx.taikyo.kaiyakuYmd).format("YYYY/MM/DD") : ""), 1)
                                            ]),
                                            _createElementVNode("tr", null, [
                                                _cache[10] || (_cache[10] = _createElementVNode("th", null, "退去理由", -1)),
                                                _createElementVNode("td", null, [
                                                    _createVNode(_component_q_list, { dense: "" }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_q_item, null, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_q_option_group, {
                                                                        modelValue: _ctx.taikyo.taikyoRiyuKb,
                                                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.taikyo.taikyoRiyuKb) = $event)),
                                                                        options: _ctx.taikyoForInput.taikyoReasons,
                                                                        disable: ""
                                                                    }, null, 8, ["modelValue", "options"])
                                                                ]),
                                                                _: 1
                                                            })
                                                        ]),
                                                        _: 1
                                                    })
                                                ])
                                            ]),
                                            (_ctx.taikyoEntryPageViwModel.isRequiredTaikyoRiyu)
                                                ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                                                    _cache[11] || (_cache[11] = _createElementVNode("th", null, "退去理由の詳細", -1)),
                                                    _createElementVNode("td", null, _toDisplayString(_ctx.taikyo.taikyoRiyu), 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("tr", null, [
                                                _cache[12] || (_cache[12] = _createElementVNode("th", null, [
                                                    _createTextVNode("連絡先住所（転居先）"),
                                                    _createElementVNode("br"),
                                                    _createTextVNode("書類送付先")
                                                ], -1)),
                                                _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.address ? _ctx.address : ""), 1)
                                            ])
                                        ])
                                    ])
                                ]),
                                (_ctx.myPageStore.selectedNyukyokeiyaku.roomSb !== _ctx.RoomSb.Parking)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                        _createElementVNode("table", _hoisted_15, [
                                            _createElementVNode("tbody", null, [
                                                _createElementVNode("tr", null, [
                                                    _cache[16] || (_cache[16] = _createElementVNode("th", null, [
                                                        _createTextVNode("引越し関連業務について "),
                                                        _createElementVNode("br"),
                                                        _createTextVNode("（サカイ引越センター）")
                                                    ], -1)),
                                                    _cache[17] || (_cache[17] = _createElementVNode("td", null, " ご提供頂いた個人情報は、引越し関連業務（サカイ引越センター）についてお客様との連絡や書類の送付および引越しに関する手続きを円滑に行うために、利用させて頂きます。 ", -1)),
                                                    _createElementVNode("td", null, [
                                                        _createVNode(_component_q_option_group, {
                                                            modelValue: _ctx.taikyo.movingServices,
                                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.taikyo.movingServices) = $event)),
                                                            options: _ctx.movingServicesList,
                                                            disable: true
                                                        }, null, 8, ["modelValue", "options"])
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_card_actions, {
                            class: "q-pb-lg",
                            align: "center"
                        }, {
                            default: _withCtx(() => [
                                (_ctx.taikyo.status === _ctx.NyukyoStatus.CurrentlyMovingIn || _ctx.isMultipleKeiyaku)
                                    ? (_openBlock(), _createBlock(_component_q_btn, {
                                        key: 0,
                                        label: "戻る",
                                        class: "btn-route col-5 col-md-3",
                                        color: "grey-8",
                                        icon: "navigate_before",
                                        onClick: _ctx.back
                                    }, null, 8, ["onClick"]))
                                    : (_openBlock(), _createBlock(_component_q_btn, {
                                        key: 1,
                                        label: "トップに戻る",
                                        class: "btn-route col-8 col-md-4",
                                        color: "grey-8",
                                        icon: "navigate_before",
                                        onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.router.push({ name: 'top' })))
                                    })),
                                (_ctx.taikyo.status === _ctx.NyukyoStatus.CurrentlyMovingIn)
                                    ? (_openBlock(), _createBlock(_component_q_btn, {
                                        key: 2,
                                        label: "申請",
                                        class: "btn-route col-5 col-md-3",
                                        color: "green-7",
                                        "icon-right": "navigate_next",
                                        onClick: _ctx.apply
                                    }, null, 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ])
        ]),
        _: 1
    }));
}
